"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = arrayToString;
function arrayToString(array) {
  return (array == null ? void 0 : array.length) > 0 ? array.toString() : undefined;
}